import type { FC } from "react";
import { useStaticResourcesQuery } from "@src/queries/common";
import { ReactSVG } from "react-svg";

interface IconSessionTypeProps {
  consultType: string | undefined;
  className?: string;
}

export const IconSessionType: FC<IconSessionTypeProps> = ({
  consultType,
  className = "",
}) => {
  const { data: resourceUrls, isLoading } = useStaticResourcesQuery();

  return isLoading || !consultType ? null : (
    <ReactSVG
      src={`${resourceUrls?.sessionType.iconUrl}/${consultType}.svg`}
      title={consultType}
      className={`w-6 h-6 *:fill-indigo-800 ${className}`}
    />
  );
};
